import * as angular from "angular";
import {BringozToastService} from "../../commons/services/bringoz-toast.service";

export class SitesAlertsService {

  /* @ngInject */
  constructor(private bringozToastService: BringozToastService) {
  }

  // CREATE //
  createSuccess() {
    const message = {
      body: 'SITE_CREATE_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  createError() {
    const message = {
      body: 'SITE_CREATE_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // DELETE //
  deleteSuccess(site) {
    const message = {
      body: 'SITE_DELETE_SUCCESS'
    };
    return this.bringozToastService.success(message, site)
  }

  deleteError() {
    const message = {
      body: 'SITE_DELETE_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }


  // UPDATE //
  updateSuccess() {
    const message = {
      body: 'SITE_UPDATE_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  updateError() {
    const message = {
      body: 'SITE_UPDATE_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // UPDATE FLAVOR//
  updateFlavorSuccess() {
    const message = {
      body: 'SITE_UPDATE_FLAVOR_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  updateFlavorError() {
    const message = {
      body: 'SITE_UPDATE_FLAVOR_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // UPDATE MODULE//
  updateModuleSuccess() {
    const message = {
      body: 'SITE_UPDATE_MODULE_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  updateModuleError() {
    const message = {
      body: 'SITE_UPDATE_MODULE_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // CREATE AGREEMENT//
  createAgreementSuccess() {
    const message = {
      body: 'SITE_CREATE_AGREEMENT_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  createAgreementError() {
    const message = {
      body: 'SITE_CREATE_AGREEMENT_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // UPDATE AGREEMENT//
  updateAgreementSuccess() {
    const message = {
      body: 'SITE_UPDATE_AGREEMENT_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  updateAgreementError() {
    const message = {
      body: 'SITE_UPDATE_AGREEMENT_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

}

angular
  .module('bringoz.admin.sites')
  .service('sitesAlertsService', SitesAlertsService);
